import * as React from "react";
const SvgNotificationIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 6 }));
export default SvgNotificationIcon;
